module.exports = __webpack_public_path__ + "img/img_futa_clef.45a8bacd.png";